module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.c90d94f.woff2";